import { Component, Inject, HostListener, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-review-comment-dialog',
  templateUrl: './review-comment-dialog.component.html',
  styleUrls: ['./review-comment-dialog.component.scss'],
  standalone: false,
})
export class ReviewCommentDialogComponent implements AfterViewInit {
  // Reactive control for the comment textarea
  content = new FormControl('', { validators: [Validators.required] });

  // Use an optional ViewChild with explicit options to avoid template analyzer warnings
  @ViewChild('commentTextarea', { static: false }) textareaRef?: ElementRef<HTMLTextAreaElement>;

  constructor(
    private readonly dialogRef: MatDialogRef<ReviewCommentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { nodeId: number; selectionText?: string },
  ) {
    // If caller provided any initial text, seed it
    if ((data as any)?.initialText) {
      this.content.setValue((data as any).initialText);
    }
  }

  ngAfterViewInit(): void {
    // Ensure focus is applied after the dialog opens; use a short timeout so Angular Material finishes opening animation
    try {
      setTimeout(() => {
        try {
          this.textareaRef?.nativeElement?.focus();
          // Move cursor to end
          const val = this.textareaRef?.nativeElement?.value;
          if (val) {
            this.textareaRef.nativeElement.selectionStart = this.textareaRef.nativeElement.selectionEnd = val.length;
          }
        } catch {}
      }, 50);
    } catch {}
  }

  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    const val = (this.content.value || '').toString().trim();
    if (!val) return;
    this.dialogRef.close(val);
  }

  // Allow Ctrl+Enter or Cmd+Enter to submit quickly
  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    const isEnter = event.key === 'Enter';
    const isMod = event.ctrlKey || event.metaKey;
    if (isEnter && isMod) {
      event.preventDefault();
      this.save();
    }
  }
}
